module.exports = __webpack_public_path__ + "img/cloudca.1095d0cc.svg";